export default "__VITE_ASSET__D5JqavqQ__"